import { render } from "./ImportAttendances.vue?vue&type=template&id=162e9967"
import script from "./ImportAttendances.vue?vue&type=script&lang=js"
export * from "./ImportAttendances.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__